import { render, staticRenderFns } from "./ProductsLayout.vue?vue&type=template&id=9584a0b2&scoped=true&"
import script from "./ProductsLayout.vue?vue&type=script&lang=js&"
export * from "./ProductsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9584a0b2",
  null
  
)

export default component.exports